module.exports = __webpack_public_path__ + "static/media/tick.45c413c7.svg";